<template>
  <button
    v-bind:class="{'scale-box':scale}"
    ondragstart="return false;"
    @click="handleClick"
    @touchstart="handleScale"
    @mousedown="handleScale"
    @mouseup="handleRestore"
    @mouseout="handleRestore"
    @touchcancel="handleRestore"
    @touchend="handleRestore"
  >
    <img :src="gamePic" ondragstart="return false;" class="img" />
  </button>
</template>
<script>
export default {
  name: "scaleBox",
  props: {
    gamePic: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      scale: false
    };
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
    handleScale() {
      this.scale = true;
    },
    handleRestore() {
      this.scale = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.scale-box {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
}
.img {
  width: 100%;
  height: 100%;
  float: left;
}
</style>